import {getAuthCache} from "/@/utils/auth";
import { DB_DICT_DATA_KEY, FIELDS_COLUMNS_CONFIG_KEY, SERVER_CONFIG_KEY } from "/@/enums/cacheEnum";
import {defHttp} from "/@/utils/http/axios";
import {getLocalStorageItem} from "/@/utils/index";

/**
 * 从缓存中获取字典配置
 * @param code
 * @param isPublic 是否全量字典，默认true
 */
export const getDictItemsByCode= (code,isPublic= true) =>  {
  let dictArr= [];
  let dictCache = getAuthCache(DB_DICT_DATA_KEY);
  if (dictCache && dictCache[code]) {
    dictArr = dictCache[code]||[];
    if(!isPublic){
      dictArr = dictArr.filter(item=>item.tenantStatus===1)
    }
  }
  return dictArr;
}
/**
 * 获取字典数组
 * @param dictCode 字典Code
 * @return List<Map>
 */
export const initDictOptions = (code) =>{
  //1.优先从缓存中读取字典配置
  if(getDictItemsByCode(code)){
    return new Promise((resolve, reject) => {
      resolve(getDictItemsByCode(code))
    })
  }
  //2.获取字典数组
  return defHttp.get({url: `/sys/dict/getDictItems/${code}`});
};
/**
 * 获取字典数组
 * @param code 字典Code
 * @param params 查询参数
 * @return List<Map>
 */
export const ajaxGetDictItems = (code, params)=>defHttp.get({url:`/sys/dict/getDictItems/${code}`,params});


export const getDictValue = (catelog, key) => {
  let arr = getDictItemsByCode(catelog)
  if (Array.isArray(arr)) {
    let it = arr.find(item => {
      return item.value == key
    })
    return it?.label
  } else {
    return ''
  }  
}

/**
 * @desc 获取字典值对应的text
 * @param value 字典code
 * @param dictData 字典数组
 * @returns String
 */
 export const getDictLabelByDicts = (value, dictData) => {
  if (!value && value != 0) return '-';
  let it = dictData.find((item) => {
    return item.value == value;
  });
  return it?.label || '-'
};

/**
 * @desc 获取字典值对应的text
 * @param value 字典值code值集合
 * @param dictCode 字典Code
 * @returns String
 */
export const getDictMultipleLabelByDicts = (value, dictCode, joinStr='；') => {
  const dictArr = getDictItemsByCode(dictCode) ?? []
  if (value?.length > 0 && dictArr?.length > 0 ) {
    return dictArr.filter(item => value.includes(item.value)).map(item => item.label)?.join(joinStr) ?? ''
  }
  return ''
};

/**
 * 从缓存中获取nacos配置
 * @param key
 */
export const getServerSysConfigByKey= (key) =>  {
  // @ts-ignore
  // return getAuthCache(SERVER_CONFIG_KEY)?.[key];
  return getLocalStorageItem(SERVER_CONFIG_KEY)?.[key];
}

/*
* 从缓存中获取实体列表字段显隐配置
* */
export const getFieldsColumnsConfigByEntityId = (key) => {
  // console.log(getAuthCache(FIELDS_COLUMNS_CONFIG_KEY))
  // return getAuthCache(FIELDS_COLUMNS_CONFIG_KEY)?.[key]
  return getLocalStorageItem(FIELDS_COLUMNS_CONFIG_KEY)?.[key]
}
/*
* 全量获取缓存用户字段显隐缓存数据
* */
export const getAllFieldsColumnsConfig = () => {
  // return getAuthCache(FIELDS_COLUMNS_CONFIG_KEY)
  return getLocalStorageItem(FIELDS_COLUMNS_CONFIG_KEY)
}
